import { pickBy } from 'lodash'

import { CUSTOM_EVENT_SURVEY_TRIGGER } from '@shared/config/events'
import { SURVEY_TOUCHPOINT_SUBMIT } from '@shared/config/constants'

import basketStore from '@shared/store/basket'
import partnerStore from '@shared/store/partner'
import useApplication from '@shared/hooks/useApplication'

export default function useSurvey() {
  // HOOKS
  const { dispatchCustomEvent } = useApplication()

  // METHODS
  function triggerSurvey(touchPoint = SURVEY_TOUCHPOINT_SUBMIT) {
    // FLEX-203 no survey for collective
    if (!partnerStore.isCollective.value) {
      // only send vepaNr if non default

      const { basketId, language } = basketStore.basket
      const riskAssessment =
        basketStore.basket.persons.filter(p => p.healthQuestionAnswers.length).length > 0 ? 'yes' : 'no'

      const payload = pickBy(
        {
          basketId,
          language,
          riskAssessment,
          touchPoint,
          vepaNr: btoa(partnerStore.basketDistributionPartnerNumber.value),
        },
        x => !!x
      )

      dispatchCustomEvent(CUSTOM_EVENT_SURVEY_TRIGGER, payload)
    }
  }

  return {
    triggerSurvey,
  }
}
